export const ApplicationQueryKeys = {
  all: () => ["applications"],
  single: (applicationId: string) => [
    ...ApplicationQueryKeys.all(),
    applicationId,
  ],
};
